import React from 'react';

import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';

const NotFound = () => <SectionTitle title="Sorry, page not found." />;

export default NotFound;
